import React from 'react';
import InsightMaster from './InsightMaster';

function Categories() {
  return (
    <InsightMaster
      title="Categories"
      modalTitle="Add Category"
      addButtonText="Add Category"
      searchPlaceholder="Search categories..."
      nameLabel="Name *"
      namePlaceholder="Category name"
      itemType="CATEGORY"
    />
  );
}

export default Categories;
